/// <amd-module name="Artifacts/Root/Validator" />
import * as Url from "VSS/Platform/Util/Url";

const coreInvalidCharacters = [
  "~",
  ";",
  "{",
  "}",
  "'",
  "+",
  "=",
  ",",
  "<",
  ">",
  "|",
  "/",
  "\\",
  "?",
  ":",
  "&",
  "$",
  "*",
  '"',
  "#",
  "[",
  "]",
  "%",
];

const feedNameInvalidChars = coreInvalidCharacters.concat(" ", "@");
const upstreamInvalidChars = coreInvalidCharacters;

function validateName(
  name: string,
  maxLength: number,
  invalidChars: string[],
  invalidLeadingChars: string[],
  invalidTrailingChars: string[],
): boolean {
  if (name == null || name.length === 0 || name.length > maxLength) {
    return false;
  }

  for (const invalidCharacter of invalidChars) {
    if (name.indexOf(invalidCharacter) !== -1) {
      return false;
    }
  }

  for (const invalidCharacter of invalidLeadingChars) {
    if (name.charAt(0) === invalidCharacter) {
      return false;
    }
  }

  for (const invalidCharacter of invalidTrailingChars) {
    if (name.charAt(name.length - 1) === invalidCharacter) {
      return false;
    }
  }

  return true;
}

/**
 * Validates feed names
 * Name should not start with _ or . and end with .
 * Max length is 64
 * Should not contain special charaters
 */
export function isValidFeedName(name: string): boolean {
  const invalidLeadingChars = ["_", "."];
  const invalidTrailingChars = ["."];
  return validateName(name, 64, feedNameInvalidChars, invalidLeadingChars, invalidTrailingChars);
}

/**
 * Validates release-view names
 * Name should not start with _ or . and end with .
 * Max length is 64
 * Should not contain special charaters
 */
export function validateViewName(name: string): boolean {
  // currently the same as feed name validation
  return isValidFeedName(name);
}

/**
 * Validates upstream source names
 * Name should not start with _ or . and end with .
 * Max length is 30
 * Should not contain special charaters (but allows ' ' and '@')
 */
export function isUpstreamSourceNameValid(name: string): boolean {
  const invalidLeadingChars = ["_", "."];
  const invalidTrailingChars = ["."];
  return validateName(name, 64, upstreamInvalidChars, invalidLeadingChars, invalidTrailingChars);
}

/**
 * Validates upstream source location
 * Should be a valid url using the http or https protocol
 */
export function isUrlValid(location: string): boolean {
  const uri = new Url.Uri(location);
  if (
    (uri.scheme !== "https" && uri.scheme !== "http") ||
    !isUrlWithinConstraints(location) ||
    uri.host === ""
  ) {
    return false;
  }
  return true;
}

/**
 * Verifies that the given url is within the constraints of 2000 characters.
 *
 * @param url The url to verify.
 * @returns {boolean}
 */
function isUrlWithinConstraints(url: string): boolean {
  return url.length <= 2000;
}
